<template>
  <section>
    <div v-if="loading" class="loading-spinner">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
      <p>Loading Trades...</p>
    </div>
    <base-card>
      <h2>Login!</h2>
      <p v-if="error" class="error-text">{{ error }}</p>
      <login-form @save-data="saveData" />
    </base-card>
  </section>
</template>
  
<script>
import LoginForm from '../../components/users/LoginForm.vue';

export default {
  components: {
    LoginForm
  },
  data() {
    return {
      loading: false,
      error: null
    };
  },
  methods: {
    async saveData(data) {
      this.loading = true;
      this.error = null;
      
      try {
        // Wait for the login action to complete
        await this.$store.dispatch('users/login', data);
        
        // Only routes if dispatch succeeded
        this.$router.replace('/user/token');
      } catch (err) {
        // Keeps user on the page and shows the error
        this.error = err.message || 'Authentication failed. Please check your credentials.';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.error-text {
  color: red;
  font-weight: bold;
  margin-bottom: 1rem;
}
</style>